namespace Config {
  export const VITE_AUTH_PROVIDER: string =
    window.AppConfig.VITE_AUTH_PROVIDER || import.meta.env.VITE_AUTH_PROVIDER;
  export const VITE_AUTH_PROVIDER_OIDC_AUTHORITY: string | null =
    window.AppConfig.VITE_AUTH_PROVIDER_OIDC_AUTHORITY ||
    import.meta.env.VITE_AUTH_PROVIDER_OIDC_AUTHORITY;
  export const VITE_AUTH_PROVIDER_OIDC_CLIENTID: string | null =
    window.AppConfig.VITE_AUTH_PROVIDER_OIDC_CLIENTID ||
    import.meta.env.VITE_AUTH_PROVIDER_OIDC_CLIENTID;
  export const VITE_AUTH_PROVIDER_OIDC_REDIRECT_URL: string | null =
    window.AppConfig.VITE_AUTH_PROVIDER_OIDC_REDIRECT_URL ||
    import.meta.env.VITE_AUTH_PROVIDER_OIDC_REDIRECT_URL;
  export const VITE_AUTH_PROVIDER_OIDC_SCOPE: string | null =
    window.AppConfig.VITE_AUTH_PROVIDER_OIDC_SCOPE ||
    import.meta.env.VITE_AUTH_PROVIDER_OIDC_SCOPE;
  export const VITE_FIREBASE_API_KEY: string | null =
    window.AppConfig.VITE_FIREBASE_API_KEY ||
    import.meta.env.VITE_FIREBASE_API_KEY;
  export const VITE_FIREBASE_AUTH_DOMAIN: string | null =
    window.AppConfig.VITE_FIREBASE_AUTH_DOMAIN ||
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  export const VITE_GOOGLE_ANALYTICS_KEY: string | null =
    window.AppConfig.VITE_GOOGLE_ANALYTICS_KEY ||
    import.meta.env.VITE_GOOGLE_ANALYTICS_KEY;
  export const VITE_HUBSPOT_REGION: string | null =
    window.AppConfig.VITE_HUBSPOT_REGION || import.meta.env.VITE_HUBSPOT_REGION;
  export const VITE_HUBSPOT_PORTAL_ID: string | null =
    window.AppConfig.VITE_HUBSPOT_PORTAL_ID ||
    import.meta.env.VITE_HUBSPOT_PORTAL_ID;
  export const VITE_HUBSPOT_CONTACT_FORM_ID: string | null =
    window.AppConfig.VITE_HUBSPOT_CONTACT_FORM_ID ||
    import.meta.env.VITE_HUBSPOT_CONTACT_FORM_ID;
  export const VITE_SENTRY_ENABLE: string | null =
    window.AppConfig.VITE_SENTRY_ENABLE || import.meta.env.VITE_SENTRY_ENABLE;
  export const VITE_SENTRY_DSN: string | null =
    window.AppConfig.VITE_SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN;
  export const VITE_SENTRY_ENVIRONMENT: string | null =
    window.AppConfig.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.VITE_SENTRY_ENVIRONMENT;
  export const VITE_DATADOG_ENABLE: string | null =
    window.AppConfig.VITE_DATADOG_ENABLE || import.meta.env.VITE_DATADOG_ENABLE;
  export const VITE_DATADOG_APP_ID: string | null =
    window.AppConfig.VITE_DATADOG_APP_ID || import.meta.env.VITE_DATADOG_APP_ID;
  export const VITE_DATADOG_CLIENT_TOKEN: string | null =
    window.AppConfig.VITE_DATADOG_CLIENT_TOKEN ||
    import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
  export const VITE_DATADOG_ENVIRONMENT: string | null =
    window.AppConfig.VITE_DATADOG_ENVIRONMENT ||
    import.meta.env.VITE_DATADOG_ENVIRONMENT;
  export const VITE_DATADOG_SERVICE: string | null =
    window.AppConfig.VITE_DATADOG_SERVICE ||
    import.meta.env.VITE_DATADOG_SERVICE;
  export const VITE_DATADOG_SESSION_SAMPLE_RATE: string | null =
    window.AppConfig.VITE_DATADOG_SESSION_SAMPLE_RATE ||
    import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE;
  export const VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE: string | null =
    window.AppConfig.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE ||
    import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE;
  export const VITE_CHANGELOG_PATH: string | null =
    window.AppConfig.VITE_CHANGELOG_PATH || import.meta.env.VITE_CHANGELOG_PATH;
  export const VITE_COMMUNITY_INVITE_LINK: string | null =
    window.AppConfig.VITE_COMMUNITY_INVITE_LINK ||
    import.meta.env.VITE_COMMUNITY_INVITE_LINK;
  export const VITE_HIDE_COMMUNITY_ICON: string | null =
    window.AppConfig.VITE_HIDE_COMMUNITY_ICON ||
    import.meta.env.VITE_HIDE_COMMUNITY_ICON;
  export const VITE_HIDE_STATUS_LINK: string | null =
    window.AppConfig.VITE_HIDE_STATUS_LINK ||
    import.meta.env.VITE_HIDE_STATUS_LINK;
  // Statuspage component allowlist for the incident banner (comma-separated
  // component names or ids). Use the deployment marker name(s) from the
  // "Deployments" / "Dedicated Instances" groups in summary.json — e.g.
  // "mondoo-us,global". Include "global" so org-wide incidents also surface on
  // this deployment (markers are not auto-watched). Empty = show the global
  // status rollup (today's behavior). See incidentTargeting.ts.
  export const VITE_INCIDENT_COMPONENTS: string | null =
    window.AppConfig.VITE_INCIDENT_COMPONENTS ||
    import.meta.env.VITE_INCIDENT_COMPONENTS;
  export const VITE_REGIONS: string | null =
    window.AppConfig.VITE_REGIONS || import.meta.env.VITE_REGIONS;
  export const VITE_RELEASE: string | null =
    window.AppConfig.VITE_RELEASE || import.meta.env.VITE_RELEASE;
  export const VITE_PRIVATE_INSTANCE: string | null =
    window.AppConfig.VITE_PRIVATE_INSTANCE ||
    import.meta.env.VITE_PRIVATE_INSTANCE;
  export const VITE_SESSION_MAX_DURATION: string | null =
    window.AppConfig.VITE_SESSION_MAX_DURATION ||
    import.meta.env.VITE_SESSION_MAX_DURATION;
  export const VITE_INTERCOM_APP_ID: string | null =
    window.AppConfig.VITE_INTERCOM_APP_ID ||
    import.meta.env.VITE_INTERCOM_APP_ID;
  export const VITE_DISABLE_CHAT_SUPPORT: string | null =
    window.AppConfig.VITE_DISABLE_CHAT_SUPPORT ||
    import.meta.env.VITE_DISABLE_CHAT_SUPPORT;
  export const VITE_DEFAULT_FEATURES: string | null =
    window.AppConfig.VITE_DEFAULT_FEATURES ||
    import.meta.env.VITE_DEFAULT_FEATURES;
  export const VITE_INSTALL_HOST: string =
    window.AppConfig.VITE_INSTALL_HOST ||
    import.meta.env.VITE_INSTALL_HOST ||
    "install.mondoo.com";
  export const VITE_RELEASES_HOST: string =
    window.AppConfig.VITE_RELEASES_HOST ||
    import.meta.env.VITE_RELEASES_HOST ||
    "releases.mondoo.com";
}

export { Config };
